import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import AgentDashboard from "./pages/AgentDashboard";
import MarketingDashboard from "./pages/MarketingDashboard";
import DcsDashboard from "./pages/DcsDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import VpisStatistik from "./pages/VpisStatistik";
import AdminHelp from "./pages/AdminHelp";
import OdsotnostiPage from "./pages/OdsotnostiPage";
import StojaCheck from "./pages/StojaCheck";
import AppLayout from "./layout/AppLayout";
import AdminProfile from "./pages/AdminProfile";
import VpisRacuni from "./pages/VpisRacuni";
import Archive from "./pages/Archive";
import { ToastContainer } from "react-toastify";
import { ProjectsPage } from "./pages/ProjectsPage";

function App() {
    return (
        <>
            <ToastContainer />
            <Router>
                <AuthProvider>
                    <Routes>
                        {/* Public route - Login must be outside of any protection */}
                        <Route path="/login" element={<Login />} />

                        {/* Protected routes wrapped in AppLayout */}
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            {/* Default route */}
                            <Route
                                index
                                element={
                                    <ProtectedRoute>
                                        {({ user }) => {
                                            if (
                                                user?.role === "owner" ||
                                                user?.role === "manager"
                                            )
                                                return (
                                                    <Navigate
                                                        to="/pregled"
                                                        replace
                                                    />
                                                );
                                            if (user?.role === "admin")
                                                return (
                                                    <Navigate
                                                        to="/profile"
                                                        replace
                                                    />
                                                );
                                            return (
                                                <Navigate to="/login" replace />
                                            );
                                        }}
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin Routes */}
                            <Route
                                path="/projects"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <ProjectsPage />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin Routes */}
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "admin",
                                            "owner",
                                            "manager",
                                        ]}
                                    >
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Archive Route */}
                            <Route
                                path="/archive"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <Archive />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Računi Route */}
                            <Route
                                path="/racuni"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "owner",
                                            "manager",
                                            "admin",
                                        ]}
                                        isInvoices
                                    >
                                        <VpisRacuni />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Shared Routes (Owner, Manager) */}
                            <Route
                                path="/odsotnosti"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "owner",
                                            "manager",
                                            "admin",
                                        ]}
                                        isAbsences
                                    >
                                        <OdsotnostiPage />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Owner and Manager Routes */}
                            <Route
                                path="/pregled"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/agents"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <AgentDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/dcs"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <DcsDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/marketing"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <MarketingDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/stojacheck"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["owner", "manager"]}
                                    >
                                        <StojaCheck />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin and Manager Routes */}
                            <Route
                                path="/vpis-statistik"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "manager"]}
                                    >
                                        <VpisStatistik />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin Routes */}
                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute allowedRoles={["admin"]}>
                                        <AdminProfile />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/pomoc"
                                element={
                                    <ProtectedRoute allowedRoles={["admin"]}>
                                        <AdminHelp />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                    </Routes>
                </AuthProvider>
            </Router>
        </>
    );
}

export default App;
